var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.557,
    height: 15.557,
    viewBox: "0 0 15.557 15.557",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2408",
    "data-name": "Group 2408",
    transform: "translate(-1354.443 -863)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2407",
    "data-name": "Group 2407"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2406",
    "data-name": "Group 2406"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2405",
    "data-name": "Group 2405"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_3",
    "data-name": "Union 3",
    d: "M7.778,9.192,1.414,15.557,0,14.142,6.364,7.778,0,1.414,1.414,0,7.778,6.364,14.142,0l1.415,1.414L9.192,7.778l6.364,6.364-1.415,1.415Z",
    transform: "translate(1354.443 863)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtn);
export default __webpack_public_path__ + "static/media/close-btn.a28ae06bb10747905ddf0803f17ddb31.svg";
export { ForwardRef as ReactComponent };